// Aviso em tela cheia da programação do cliente, coletado por glob em core/i18n/messages.ts.
// Sem parêntese nem travessão no texto.
export default {
  pt: {
    'layout.avisoProgramacao.titulo.nova': 'Chegou programação nova',
    'layout.avisoProgramacao.titulo.reprogramacao': 'Programação reprogramada',
    'layout.avisoProgramacao.titulo.confirmacao': 'Prévia confirmada',
    'layout.avisoProgramacao.varias': 'Chegaram {{n}} programações',
    'layout.avisoProgramacao.subtitulo': 'O cliente programou pelo Hub. Confira e dê ciente para a sua dupla.',
    'layout.avisoProgramacao.tipo.nova': 'Nova',
    'layout.avisoProgramacao.tipo.reprogramacao': 'Reprogramação',
    'layout.avisoProgramacao.tipo.confirmacao': 'Confirmação',
    'layout.avisoProgramacao.por': 'Por {{quem}}',
    'layout.avisoProgramacao.antes': 'Antes',
    'layout.avisoProgramacao.agora': 'Agora',
    'layout.avisoProgramacao.horarios': 'Horários',
    'layout.avisoProgramacao.cargas': '{{n}} cargas',
    'layout.avisoProgramacao.umaCarga': '1 carga',
    'layout.avisoProgramacao.fazenda': 'Fazenda',
    'layout.avisoProgramacao.destino': 'Destino',
    'layout.avisoProgramacao.semDupla': 'Contrato sem dupla',
    'layout.avisoProgramacao.extras': 'Cargas extras: {{n}}',
    'layout.avisoProgramacao.reducoes': 'Redução de carga: {{n}}',
    'layout.avisoProgramacao.ciente': 'Ciente',
    'layout.avisoProgramacao.cienteTodas': 'Ciente de todas',
    'layout.avisoProgramacao.abrir': 'Abrir a programação',
    'layout.avisoProgramacao.abrirModulo': 'Abrir a Programação do cliente',
  },
  en: {
    'layout.avisoProgramacao.titulo.nova': 'A new schedule arrived',
    'layout.avisoProgramacao.titulo.reprogramacao': 'Schedule rescheduled',
    'layout.avisoProgramacao.titulo.confirmacao': 'Preview confirmed',
    'layout.avisoProgramacao.varias': '{{n}} schedules arrived',
    'layout.avisoProgramacao.subtitulo': 'The customer scheduled through the Hub. Check it and acknowledge for your pair.',
    'layout.avisoProgramacao.tipo.nova': 'New',
    'layout.avisoProgramacao.tipo.reprogramacao': 'Reschedule',
    'layout.avisoProgramacao.tipo.confirmacao': 'Confirmation',
    'layout.avisoProgramacao.por': 'By {{quem}}',
    'layout.avisoProgramacao.antes': 'Before',
    'layout.avisoProgramacao.agora': 'Now',
    'layout.avisoProgramacao.horarios': 'Times',
    'layout.avisoProgramacao.cargas': '{{n}} loads',
    'layout.avisoProgramacao.umaCarga': '1 load',
    'layout.avisoProgramacao.fazenda': 'Farm',
    'layout.avisoProgramacao.destino': 'Destination',
    'layout.avisoProgramacao.semDupla': 'Contract without pair',
    'layout.avisoProgramacao.extras': 'Extra loads: {{n}}',
    'layout.avisoProgramacao.reducoes': 'Load reduction: {{n}}',
    'layout.avisoProgramacao.ciente': 'Acknowledge',
    'layout.avisoProgramacao.cienteTodas': 'Acknowledge all',
    'layout.avisoProgramacao.abrir': 'Open the schedule',
    'layout.avisoProgramacao.abrirModulo': 'Open the Customer schedule',
  },
  es: {
    'layout.avisoProgramacao.titulo.nova': 'Llegó una programación nueva',
    'layout.avisoProgramacao.titulo.reprogramacao': 'Programación reprogramada',
    'layout.avisoProgramacao.titulo.confirmacao': 'Previa confirmada',
    'layout.avisoProgramacao.varias': 'Llegaron {{n}} programaciones',
    'layout.avisoProgramacao.subtitulo': 'El cliente programó por el Hub. Revise y confirme para su dupla.',
    'layout.avisoProgramacao.tipo.nova': 'Nueva',
    'layout.avisoProgramacao.tipo.reprogramacao': 'Reprogramación',
    'layout.avisoProgramacao.tipo.confirmacao': 'Confirmación',
    'layout.avisoProgramacao.por': 'Por {{quem}}',
    'layout.avisoProgramacao.antes': 'Antes',
    'layout.avisoProgramacao.agora': 'Ahora',
    'layout.avisoProgramacao.horarios': 'Horarios',
    'layout.avisoProgramacao.cargas': '{{n}} cargas',
    'layout.avisoProgramacao.umaCarga': '1 carga',
    'layout.avisoProgramacao.fazenda': 'Hacienda',
    'layout.avisoProgramacao.destino': 'Destino',
    'layout.avisoProgramacao.semDupla': 'Contrato sin dupla',
    'layout.avisoProgramacao.extras': 'Cargas extra: {{n}}',
    'layout.avisoProgramacao.reducoes': 'Reducción de carga: {{n}}',
    'layout.avisoProgramacao.ciente': 'Enterado',
    'layout.avisoProgramacao.cienteTodas': 'Enterado de todas',
    'layout.avisoProgramacao.abrir': 'Abrir la programación',
    'layout.avisoProgramacao.abrirModulo': 'Abrir la Programación del cliente',
  },
}
